<template>
  <div
    style="height: calc(100vh - 100px); overflow-y: auto; overflow-x: hidden"
  >
    <div class="text-center">
      <h3>Employee Profile</h3>
    </div>
    <b-overlay :show="isLoading" rounded="sm">
      <b-row class="pl-5 pr-5">
        <b-col cols="12">
          <b-card class="rounded-bottom shadow-sm">
            <h3 class="pl-3">
              {{ employeData.first_name }} {{ employeData.last_name }}
            </h3>
            <div class="text-right">
              <b-button
                v-if="employeData.status != 3"
                class="mr-2"
                size="sm"
                @click="openEditModal"
                variant="outline-warning"
                >Edit</b-button
              >
              <b-button
                class="mr-2"
                size="sm"
                @click="exportEmployeeData"
                variant="outline-success"
                >Export Data</b-button
              >
              <b-button
                v-if="employeData.status != 3"
                size="sm"
                variant="outline-danger"
                @click="updateStatus(3)"
                >Archive</b-button
              >
            </div>
            <hr />
            <b-row>
              <b-col class="display-flex" cols="6">
                <b-row>
                  <b-col cols="2">
                    <img
                      v-if="profileImage"
                      class="img-style"
                      :src="profileImage"
                      alt="Profile Image"
                    />
                    <b-card v-else style="width: 6rem">
                      <font-awesome-icon icon="user" size="4x" />
                    </b-card>
                  </b-col>
                  <b-col cols="10">
                    <b-row>
                      <b-col cols="6" class="p-0">
                        <div class="text-right">
                          <span>First Name: &nbsp;</span>
                        </div>
                      </b-col>
                      <b-col cols="6" class="p-0">
                        <span style="float: left" class="text-left">{{
                          employeData.first_name
                        }}</span>
                      </b-col>
                    </b-row>
                    <b-row class="mt-1">
                      <b-col cols="6" class="p-0">
                        <div class="text-right">
                          <span>Last Name: &nbsp;</span>
                        </div>
                      </b-col>
                      <b-col cols="6" class="p-0">
                        <span style="float: left" class="text-left">{{
                          employeData.last_name
                        }}</span>
                      </b-col>
                    </b-row>
                    <b-row class="mt-1">
                      <b-col cols="6" class="p-0">
                        <div class="text-right">
                          <span>Employee No: &nbsp;</span>
                        </div>
                      </b-col>
                      <b-col cols="6" class="p-0">
                        <span style="float: left" class="text-left">{{
                          employeData.id
                        }}</span>
                      </b-col>
                    </b-row>
                    <b-row class="mt-1">
                      <b-col cols="6" class="p-0">
                        <div class="text-right">
                          <span>Email Address: &nbsp;</span>
                        </div>
                      </b-col>
                      <b-col cols="6" class="p-0">
                        <span style="float: left" class="text-left">
                          <a :href="'mailto:' + employeData.email">
                            {{ employeData.email }}
                          </a></span
                        >
                      </b-col>
                    </b-row>
                    <b-row class="mt-1">
                      <b-col cols="6" class="p-0">
                        <div class="text-right">
                          <span>Division Unit: &nbsp;</span>
                        </div>
                      </b-col>
                      <b-col cols="6" class="p-0">
                        <span style="float: left" class="text-left">{{
                          employeData.department
                        }}</span>
                      </b-col>
                    </b-row>
                    <b-row class="mt-1">
                      <b-col cols="6" class="p-0">
                        <div class="text-right">
                          <span>Residence: &nbsp;</span>
                        </div>
                      </b-col>
                      <b-col cols="6" class="p-0">
                        <span style="float: left" class="text-left">{{
                          employeData.country
                        }}</span>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="6">
                <!-- class="text-right" -->
                <div class="d-flex" style="justify-content: flex-end">
                  <p>Date of Joining:&nbsp;</p>
                  <div>{{ formatDate(employeData.date_of_joining) }}</div>
                </div>
                <div class="d-flex" style="justify-content: flex-end">
                  <div>
                    <p>1st Level Non-Compliance :&nbsp;</p>
                  </div>
                  <div
                    style="
                      border: 1px solid #d4cdcd;
                      border-radius: 8px;
                      height: 50px;
                      width: 203px;
                      overflow: auto;
                    "
                  >
                    <div
                      v-if="
                        complianceEmailsData &&
                        complianceEmailsData.compliance_emails &&
                        complianceEmailsData.compliance_emails.first_level
                      "
                    >
                      <p
                        v-for="(emails, index) in complianceEmailsData
                          .compliance_emails.first_level"
                        :key="index"
                        style="
                          border: 1px solid #f4772e;
                          border-radius: 10px;
                          background-color: #f4772e;
                          color: white;
                          width: 180px;
                          margin: 5px 0 5px 10px;
                        "
                      >
                        {{ emails }}
                      </p>
                    </div>
                  </div>
                </div>

                <div class="d-flex mt-2" style="justify-content: flex-end">
                  <div>
                    <p>2nd Level Non-Compliance :&nbsp;</p>
                  </div>
                  <div
                    style="
                      border: 1px solid #d4cdcd;
                      border-radius: 8px;
                      height: 50px;
                      width: 203px;
                      overflow: auto;
                    "
                  >
                    <div
                      v-if="
                        complianceEmailsData &&
                        complianceEmailsData.compliance_emails &&
                        complianceEmailsData.compliance_emails.second_level
                      "
                    >
                      <p
                        v-for="(emails, index) in complianceEmailsData
                          .compliance_emails.second_level"
                        :key="index"
                        style="
                          border: 1px solid #f4772e;
                          border-radius: 10px;
                          background-color: #f4772e;
                          color: white;
                          width: 180px;
                          margin: 5px 0 5px 10px;
                        "
                      >
                        {{ emails }}
                      </p>
                    </div>
                  </div>
                </div>
              </b-col>
              <b-overlay :show="showUpdateStatus" no-wrap>
                <template v-slot:overlay>
                  <div
                    v-if="processing"
                    class="text-center p-4 bg-primary text-light rounded"
                  >
                    <font-awesome-icon size="lg" icon="cloud-upload-alt" />
                    <div class="mb-3">Archiving...</div>
                    <b-progress
                      min="1"
                      max="20"
                      :value="counter"
                      variant="success"
                      height="3px"
                      class="mx-n4 rounded-0"
                    ></b-progress>
                  </div>
                  <div
                    v-else
                    ref="dialog"
                    tabindex="-1"
                    role="dialog"
                    aria-modal="false"
                    aria-labelledby="form-confirm-label"
                    class="text-center p-3"
                  >
                    <p>
                      <strong id="form-confirm-label"
                        >Are you sure you want archive employees ?</strong
                      >
                    </p>
                    <div>
                      <b-button
                        variant="outline-success"
                        class="mr-3"
                        @click="resetUpdateStatus"
                        >Cancel</b-button
                      >
                      <b-button
                        variant="outline-danger"
                        @click="updateStatusCall"
                        >Yes</b-button
                      >
                    </div>
                  </div>
                </template>
              </b-overlay>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-overlay>
    <b-row class="pl-5 pr-5 mt-3">
      <b-col cols="6">
        <b-row>
          <b-col cols="12">
            <b-overlay :show="employeeTasksLoading" rounded="sm">
              <b-card class="card-height">
                <b-navbar toggleable="lg" type="dark" variant="light">
                  <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
                  <b-navbar-brand href="#" class="text-dark">
                    <strong>Policies</strong>
                  </b-navbar-brand>

                  <b-collapse id="nav-collapse" is-nav>
                    <!-- Right aligned nav items -->
                    <b-navbar-nav class="ml-auto">
                      <b-nav-form>
                        <b-button
                          variant="outline-info"
                          size="sm"
                          class="mr-2"
                          @click="reloadTasksTable('tasks-data-table-policy')"
                        >
                          Reload
                        </b-button>
                      </b-nav-form>
                    </b-navbar-nav>
                  </b-collapse>
                </b-navbar>
                <b-table
                  class="mx-1"
                  ref="table"
                  bordered
                  id="tasks-data-table-policy"
                  busy.sync="true"
                  :items="getOnboardingPolicyTaskData"
                  :fields="employeData.status == 3 ? tasksFieldsArchived : tasksFields"
                  responsive="sm"
                >
               <template v-slot:cell(action)="data">
                    <b-btn v-if="data.item.archieve_status != '3'" @click="onShowDeleteModal(data,'tasks-data-table-policy')" variant="outline-danger" size="sm">
                      <font-awesome-icon  icon="trash" />
                    </b-btn>
                    <b-btn class="mt-1" v-if="data.item.task_status != '4'" @click="onShowForceCompleteModal(data,'tasks-data-table-policy')" variant="outline-warning" size="sm">
                      Force Complete
                    </b-btn>
               </template>
                  <template v-slot:cell(created_at)="data">
                    <p>{{ createdAtDate(data.item.created_at) }}</p>
                  </template>
                  <template v-slot:cell(task_title)="data">
                    <p v-if="data.item.form_type == 4">
                      {{ data.item.task_title }}
                    </p>
                    <p v-else class="link-text" @click="setUserTaskUrl(data)">
                      {{ data.item.task_title }}
                    </p>
                  </template>
                  <template v-slot:cell(task_status)="data">
                    <b-badge v-if="data.item.task_status == '0'" variant="info"
                      >Open</b-badge
                    >
                    <b-badge
                      v-if="data.item.task_status == '1'"
                      variant="warning"
                      >In Progress</b-badge
                    >
                    <b-badge
                      v-if="data.item.task_status == '2'"
                      variant="danger"
                      >On hold</b-badge
                    >
                    <b-badge v-if="data.item.task_status == '3'" variant="dark"
                      >Review</b-badge
                    >
                    <b-badge
                      v-if="data.item.task_status == '4'"
                      variant="success"
                      >Complete</b-badge
                    >
                  </template>
                </b-table>
              </b-card>
            </b-overlay>
          </b-col>
          <b-col class="mt-3" cols="12">
            <b-overlay :show="employeeTasksLoading" rounded="sm">
              <b-card class="card-height">
                <b-navbar toggleable="lg" type="dark" variant="light">
                  <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
                  <b-navbar-brand href="#" class="text-dark">
                    <strong>Training</strong>
                  </b-navbar-brand>

                  <b-collapse id="nav-collapse" is-nav>
                    <!-- Right aligned nav items -->
                    <b-navbar-nav class="ml-auto">
                      <b-nav-form>
                        <b-button
                          variant="outline-info"
                          size="sm"
                          class="mr-2"
                          @click="reloadTasksTable('tasks-data-table-training')"
                        >
                          Reload
                        </b-button>
                      </b-nav-form>
                    </b-navbar-nav>
                  </b-collapse>
                </b-navbar>
                <b-table
                  class="mx-1"
                  ref="table"
                  bordered
                  id="tasks-data-table-training"
                  busy.sync="true"
                  :items="getOnboardingTrainingTaskData"
                  :fields="employeData.status == 3 ? tasksFieldsArchived : tasksFields"
                  responsive="sm"
                >
                   <template v-slot:cell(action)="data">
                    <b-btn v-if="data.item.archieve_status != '3'" @click="onShowDeleteModal(data,'tasks-data-table-training')" variant="outline-danger" size="sm">
                      <font-awesome-icon  icon="trash" />
                    </b-btn>
                     <b-btn class="mt-1" v-if="data.item.task_status != '4'" @click="onShowForceCompleteModal(data,'tasks-data-table-training')" variant="outline-warning" size="sm">
                      Force Complete
                    </b-btn>
               </template>
                  <template v-slot:cell(created_at)="data">
                    <p>{{ createdAtDate(data.item.created_at) }}</p>
                  </template>
                  <template v-slot:cell(task_title)="data">
                    <p v-if="data.item.form_type == 4">
                      {{ data.item.task_title }}
                    </p>
                    <p v-else class="link-text" @click="setUserTaskUrl(data)">
                      {{ data.item.task_title }}
                    </p>
                  </template>
                  <template v-slot:cell(task_status)="data">
                    <b-badge v-if="data.item.task_status == '0'" variant="info"
                      >Open</b-badge
                    >
                    <b-badge
                      v-if="data.item.task_status == '1'"
                      variant="warning"
                      >In Progress</b-badge
                    >
                    <b-badge
                      v-if="data.item.task_status == '2'"
                      variant="danger"
                      >On hold</b-badge
                    >
                    <b-badge v-if="data.item.task_status == '3'" variant="dark"
                      >Review</b-badge
                    >
                    <b-badge
                      v-if="data.item.task_status == '4'"
                      variant="success"
                      >Complete</b-badge
                    >
                  </template>
                </b-table>
              </b-card>
            </b-overlay>
          </b-col>
          <b-col class="mt-3" cols="12">
            <b-overlay :show="employeeTasksLoading" rounded="sm">
              <b-card class="card-height">
                <b-navbar toggleable="lg" type="dark" variant="light">
                  <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
                  <b-navbar-brand href="#" class="text-dark">
                    <strong>Certifications</strong>
                  </b-navbar-brand>

                  <b-collapse id="nav-collapse" is-nav>
                    <!-- Right aligned nav items -->
                    <b-navbar-nav class="ml-auto">
                      <b-nav-form>
                        <b-button
                          variant="outline-info"
                          size="sm"
                          class="mr-2"
                          @click="
                            reloadTasksTable('tasks-data-table-certification')
                          "
                        >
                          Reload
                        </b-button>
                      </b-nav-form>
                    </b-navbar-nav>
                  </b-collapse>
                </b-navbar>
                <b-table
                  class="mx-1"
                  ref="table"
                  bordered
                  id="tasks-data-table-certification"
                  busy.sync="true"
                  :items="getOnboardingCertificationTaskData"
                  :fields="employeData.status == 3 ? tasksFieldsArchived : tasksFields"
                  responsive="sm"
                >
                   <template v-slot:cell(action)="data">
                    <b-btn  v-if="data.item.archieve_status != '3'" @click="onShowDeleteModal(data,'tasks-data-table-certification')" variant="outline-danger" size="sm">
                      <font-awesome-icon  icon="trash" />
                    </b-btn>
                     <b-btn class="mt-1" v-if="data.item.task_status != '4'" @click="onShowForceCompleteModal(data,'tasks-data-table-certification')" variant="outline-warning" size="sm">
                      Force Complete
                    </b-btn>
               </template>
                  <template v-slot:cell(created_at)="data">
                    <p>{{ createdAtDate(data.item.created_at) }}</p>
                  </template>
                  <template v-slot:cell(task_title)="data">
                    <p v-if="data.item.form_type == 4">
                      {{ data.item.task_title }}
                    </p>
                    <p v-else class="link-text" @click="setUserTaskUrl(data)">
                      {{ data.item.task_title }}
                    </p>
                  </template>
                  <template v-slot:cell(task_status)="data">
                    <b-badge v-if="data.item.task_status == '0'" variant="info"
                      >Open</b-badge
                    >
                    <b-badge
                      v-if="data.item.task_status == '1'"
                      variant="warning"
                      >In Progress</b-badge
                    >
                    <b-badge
                      v-if="data.item.task_status == '2'"
                      variant="danger"
                      >On hold</b-badge
                    >
                    <b-badge v-if="data.item.task_status == '3'" variant="dark"
                      >Review</b-badge
                    >
                    <b-badge
                      v-if="data.item.task_status == '4'"
                      variant="success"
                      >Complete</b-badge
                    >
                  </template>
                </b-table>
              </b-card>
            </b-overlay>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="6">
        <b-card>
          <b-overlay :show="employeeGiftsLoading" rounded="sm">
            <b-navbar toggleable="lg" type="dark" variant="light">
              <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
              <b-navbar-brand href="#" class="text-dark">
                <strong>Approvals</strong>
              </b-navbar-brand>

              <b-collapse id="nav-collapse" is-nav>
                <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto">
                  <b-nav-form>
                    <b-button
                      variant="outline-info"
                      size="sm"
                      class="mr-2"
                      @click="reloadGiftsTable"
                    >
                      Reload
                    </b-button>
                    <b-form-group>
                      <!-- <b-input-group size="sm">
                        <b-form-input
                          v-model="giftsFilter"
                          type="search"
                          id="filterInput"
                          placeholder="Type to Search"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            :disabled="!giftsFilter"
                            @click="giftsFilter = ''"
                            >Clear</b-button
                          >
                        </b-input-group-append>
                      </b-input-group> -->
                    </b-form-group>
                  </b-nav-form>
                </b-navbar-nav>
              </b-collapse>
            </b-navbar>
            <b-table
              class="mx-1"
              ref="table"
              bordered
              id="gifts-data-table"
              :busy.sync="employeeGiftsLoading"
              :items="getApprovalsData"
              :fields="employeData.status == 3 ? giftsFieldsArchived : giftsFields"
              :filter="giftsFilter"
              :per-page="giftsPerPage"
              :current-page="giftsCurrentPage"
              :sort-by.sync="giftsSortBy"
              :sort-desc.sync="giftsSortDesc"
              responsive="sm"
              no-sort-reset
            >
              <template v-slot:cell(title)="data">{{
                JSON.parse(data.item.title)["english"]
              }}</template>
              <template v-slot:cell(amount)="data">{{
                amountFormmater(data)
              }}</template>
              <template v-slot:cell(created_at)="data">
                {{ createdAtDate(data.item.created_at) }}
              </template>
              <template v-slot:cell(status)="data">
                <b-badge v-if="data.item.status == 1" variant="info"
                  >OPEN</b-badge
                >
                <b-badge v-else-if="data.item.status == 2" variant="success"
                  >COMPLETED</b-badge
                >
                <b-badge v-else-if="data.item.status == 3" variant="warning"
                  >ON-HOLD</b-badge
                >
                <b-badge v-else-if="data.item.status == 4" variant="success"
                  >APPROVED</b-badge
                >
                <b-badge v-else-if="data.item.status == 5" variant="danger"
                  >REJECTED</b-badge
                >
                <b-badge v-else-if="data.item.status == 6" variant="warning"
                  >In Review</b-badge
                >
                <font-awesome-icon
                  v-if="parseInt(data.item.filesCount) > 0"
                  class="ml-2"
                  icon="paperclip"
                />
              </template>
              <template v-slot:cell(actions)="data">
                <b-btn
                  v-if="data.item.isApproval != '3'"
                  :to="'/gifts-approval/' + data.item.id + '/1'"
                  size="sm"
                  variant="outline-warning"
                >
                  <font-awesome-icon icon="eye" />
                </b-btn>
              </template>
            </b-table>
            <p class="text-center mt-3">
              Showing Result From
              <b>{{ giftsFromRows }}</b> to
              <b>{{ giftsToRows }}</b>
            </p>
            <b-row>
              <b-col cols="2">
                <b-form-select
                  v-model="giftsPerPage"
                  id="perPageSelect"
                  size="sm"
                  :options="giftsPageOptions"
                ></b-form-select>
              </b-col>
              <b-col>
                <b-pagination
                  class="float-right"
                  v-model="giftsCurrentPage"
                  :total-rows="giftsRows"
                  :per-page="giftsPerPage"
                  first-text="First"
                  prev-text="Prev"
                  next-text="Next"
                  last-text="Last"
                  aria-controls="my-table"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-overlay>
        </b-card>
        <b-overlay :show="employeeTasksLoading" rounded="sm">
          <b-card class="card-height mt-3">
            <b-navbar toggleable="lg" type="dark" variant="light">
              <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
              <b-navbar-brand href="#" class="text-dark">
                <strong>Health And Safety</strong>
              </b-navbar-brand>

              <b-collapse id="nav-collapse" is-nav>
                <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto">
                  <b-nav-form>
                    <b-button
                      variant="outline-info"
                      size="sm"
                      class="mr-2"
                      @click="
                        reloadTasksTable('tasks-data-table-health-and-safety')
                      "
                    >
                      Reload
                    </b-button>
                  </b-nav-form>
                </b-navbar-nav>
              </b-collapse>
            </b-navbar>
            <b-table
              class="mx-1"
              ref="table"
              bordered
              id="tasks-data-table-health-and-safety"
              busy.sync="true"
              :items="getOnboardingHealthAndSafetyTaskData"
              :fields="employeData.status == 3 ? healthAndSafetytasksFieldsArchived : healthAndSafetytasksFields"
              responsive="sm"
            >
               <template v-slot:cell(action)="data">
                    <b-btn v-if="data.item.archieve_status != '3'" @click="onShowDeleteModal(data,'tasks-data-table-health-and-safety')" variant="outline-danger" size="sm">
                      <font-awesome-icon  icon="trash" />
                    </b-btn>
                     <b-btn class="mt-1" v-if="data.item.task_status != '4'" @click="onShowForceCompleteModal(data,'tasks-data-table-health-and-safety')" variant="outline-warning" size="sm">
                      Force Complete
                    </b-btn>
               </template>
              <template v-slot:cell(created_at)="data">
                <p>{{ createdAtDate(data.item.created_at) }}</p>
              </template>
              <template v-slot:cell(type)="data">
                <p>{{ $t(data.item.type) }}</p>
              </template>
              <template v-slot:cell(task_title)="data">
                <p v-if="data.item.form_type == 4">
                  {{ data.item.task_title }}
                </p>
                <p v-else class="link-text" @click="setUserTaskUrl(data)">
                  {{ data.item.task_title }}
                </p>
              </template>
              <template v-slot:cell(task_status)="data">
                <b-badge v-if="data.item.task_status == '0'" variant="info"
                  >Open</b-badge
                >
                <b-badge v-if="data.item.task_status == '1'" variant="warning"
                  >In Progress</b-badge
                >
                <b-badge v-if="data.item.task_status == '2'" variant="danger"
                  >On hold</b-badge
                >
                <b-badge v-if="data.item.task_status == '3'" variant="dark"
                  >Review</b-badge
                >
                <b-badge v-if="data.item.task_status == '4'" variant="success"
                  >Complete</b-badge
                >
              </template>
            </b-table>
          </b-card>
        </b-overlay>
      </b-col>
    </b-row>
    <b-row class="pl-5 pr-5 mt-3">
      <b-col cols="12">
        <b-card class="mt-2">
          <template v-slot:header>
            <b-row>
              <b-col cols="6">
                <h6 class="text-left">Audit Trail</h6>
              </b-col>
              <b-col cols="6">
                <div class="float-right">
                  <b-button
                    variant="outline-info"
                    size="sm"
                    class="mr-2"
                    @click="getActivityLog"
                  >
                    <font-awesome-icon icon="sync" />
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </template>
          <b-card-body>
            <div id="container" class="scrollFlow" style>
              <b-row>
                <b-col cols="12">
                  <b-overlay :show="isLoadingActivityLog" rounded="sm">
                    <div>
                      <ul
                        class="timeline text-left"
                        style="margin-bottom: 50px"
                      >
                        <li
                          v-for="(logData, index) in activityLogData"
                          :key="index"
                        >
                          <p class="text-muted">
                            {{ formatDate(logData.created_at) }}
                          </p>
                          <p>{{ logData.notes }}</p>
                        </li>
                      </ul>
                    </div>
                  </b-overlay>
                </b-col>
              </b-row>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      title="Edit Employee Information"
      v-model="showEditModal"
      scrollable
      size="xl"
    >
      <b-row class="px-4">
        <b-col cols="12">
          <div v-if="!submiting && !responseSuccess">
            <b-row>
              <b-col cols="12">
                <b-form-group
                  class="mt-2"
                  label-cols-md="3"
                  label-align-lg="left"
                >
                  <template #label>
                    First Name:<span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    v-model="$v.form.firstName.$model"
                    :state="
                      $v.form.firstName.$dirty
                        ? !$v.form.firstName.$error
                        : null
                    "
                    type="text"
                    size="sm"
                  ></b-form-input>
                  <b-form-invalid-feedback
                    >This Field is required.</b-form-invalid-feedback
                  >
                </b-form-group>
                <b-form-group
                  class="mt-2"
                  label-cols-md="3"
                  label-align-lg="left"
                >
                  <template #label>
                    Last Name:<span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    v-model="$v.form.lastName.$model"
                    :state="
                      $v.form.lastName.$dirty ? !$v.form.lastName.$error : null
                    "
                    type="text"
                    size="sm"
                  ></b-form-input>
                  <b-form-invalid-feedback
                    >This Field is required.</b-form-invalid-feedback
                  >
                </b-form-group>
                <b-form-group
                  class="mt-1"
                  label-cols-md="3"
                  label-align-lg="left"
                >
                  <template #label>
                    Email:<span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    v-model="$v.form.email.$model"
                    :state="$v.form.email.$dirty ? !$v.form.email.$error : null"
                    :class="invalidEmail ? 'existedEmailStyle' : null"
                    @change="checkEmailExist($event)"
                    type="email"
                  ></b-form-input>
                  <p v-if="invalidEmail" class="mb-0 text-feedback">
                    {{ invalidEmail }}
                  </p>
                </b-form-group>
                <b-form-group
                  label-align-lg="left"
                  label-cols-md="3"
                  class="mt-2"
                  :state="tagFirstLevelRequiredValidatorState"
                >
                  <template #label>
                    1st Level Non-Compliance:<span class="text-danger">*</span>
                  </template>
                  <b-form-tags
                    input-id="tags-basic"
                    tag-variant="warning"
                    tag-pills
                    :input-attrs="{
                      'aria-describedby': 'tags-validation-help',
                    }"
                    :tag-validator="tagValidatorFirst"
                    @tag-state="tagFirstEvent"
                    :state="
                      tagFirstLevelEmailValidatorState == null
                        ? tagFirstLevelRequiredValidatorState
                        : tagFirstLevelEmailValidatorState
                    "
                    v-model="form.firstLevelNonCompilanceValue"
                    invalidTagText="Please enter a valid email"
                    placeholder="Add Email Tags"
                    @input="onInputFirstLevelEmailTag"
                  ></b-form-tags>
                  <template
                    #invalid-feedback
                    v-if="tagFirstLevelEmailValidatorState == null"
                  >
                    <p>This Field is Required</p>
                  </template>
                </b-form-group>
                <b-form-group
                  label-align-lg="left"
                  label-cols-md="3"
                  class="mt-2"
                  :state="tagSecondLevelRequiredValidatorState"
                >
                  <template #label>
                    2nd Level Non-Compliance:<span class="text-danger">*</span>
                  </template>
                  <b-form-tags
                    input-id="tags-basic"
                    tag-variant="warning"
                    tag-pills
                    :input-attrs="{
                      'aria-describedby': 'tags-validation-help',
                    }"
                    :tag-validator="tagValidatorSecond"
                    @tag-state="tagSecondEvent"
                    :state="
                      tagSecondLevelEmailValidatorState == null
                        ? tagSecondLevelRequiredValidatorState
                        : tagSecondLevelEmailValidatorState
                    "
                    v-model="form.secondLevelNonCompilanceValue"
                    invalidTagText="Please enter a valid email"
                    placeholder="Add Email Tags"
                    @input="onInputSecondLevelEmailTag"
                  ></b-form-tags>
                  <template
                    #invalid-feedback
                    v-if="tagSecondLevelEmailValidatorState == null"
                  >
                    <p>This Field is Required</p>
                  </template>
                </b-form-group>
                <b-form-group
                  class="mt-2"
                  label-align-lg="left"
                  label-cols-md="3"
                  label="Date of Joining:"
                >
                  <b-form-datepicker
                    v-model="form.doj"
                    size="sm"
                    locale="en"
                    placeholder="Choose a date of joining"
                  ></b-form-datepicker>
                </b-form-group>
                <b-form-group
                  class="mt-2"
                  label-align-lg="left"
                  label-cols-md="3"
                >
                  <template #label>
                    Division/Business Unit:<span class="text-danger">*</span>
                  </template>
                  <multiselect
                    :maxHeight="220"
                    label="text"
                    track-by="value"
                    v-model="$v.form.department.$model"
                    :state="
                      $v.form.department.$dirty
                        ? !$v.form.department.$error
                        : null
                    "
                    :options="departmentsOptions"
                    :class="
                      $v.form.department.$error
                        ? 'border border-danger rounded'
                        : ''
                    "
                  >
                  </multiselect>
                </b-form-group>
                <b-form-group
                  class="mt-2"
                  label-align-lg="left"
                  label-cols-md="3"
                  label="Country of Residence:"
                >
                  <multiselect
                    :maxHeight="220"
                    v-model="form.country"
                    label="text"
                    track-by="value"
                    :options="countryOptions"
                  >
                  </multiselect>
                </b-form-group>
                <b-form-group
                  class="mt-2"
                  label-align-lg="left"
                  label-cols-md="3"
                  label="Preferred Language:"
                >
                  <!-- style="float: left; width: 65%" -->
                  <b-form-select
                    size="sm"
                    v-model="form.preferredLanguage"
                    :options="languageOptions"
                  ></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
          <div v-else-if="submiting && !responseSuccess">
            <p>Employee Information is being Updating......</p>
            <b-spinner type="grow" label="Loading..."></b-spinner>
          </div>
          <div v-else>
            <p class="my-2 text-center">
              Employee Information is successfully Updated.
              <br />
            </p>
          </div>
        </b-col>
      </b-row>
      <template v-slot:modal-footer>
        <b-button
          v-if="!submiting"
          :disabled="submiting"
          size="sm"
          @click="resetForm"
          variant="outline-danger"
          >Close</b-button
        >
        <b-button
          @click="checkValidation"
          size="sm"
          variant="outline-success"
          :disabled="submiting"
          ><span v-if="submiting">
            <b-spinner small label="Spinning"></b-spinner>
          </span>
          <span v-else>Update</span>
        </b-button>
      </template>
    </b-modal>
    <b-modal
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      title="Delete"
      v-model="deleteModal"
      scrollable
    >
    Following Action cannot be undone, are you sure you want to Delete this task <b>{{ deleteModalTitle }} </b> for 
    <b>{{ employeData.first_name }} {{ employeData.last_name }}</b> ?
     <template v-slot:modal-footer>
       <!-- v-if="!submiting"
          :disabled="submiting" -->
        <b-button
          
          size="sm"
          @click="onCloseDeleteModal"
          variant="outline-danger"
          >Close</b-button
        >
       
        <b-button
          @click="onSubmitDeleteModal"
          size="sm"
          variant="outline-success"
          :disabled="submiting"
          ><span v-if="submiting">
            <b-spinner small label="Spinning"></b-spinner>
          </span>
          <span v-else>Delete</span>
        </b-button>
      </template>
    </b-modal>
     <b-modal
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      title="Force Complete"
      v-model="forceCompleteModal"
      scrollable
    >
    Following Action cannot be undone, are you sure you want to Force complete this task <b>{{ forceCompleteModalTitle }} </b> for 
    <b>{{ employeData.first_name }} {{ employeData.last_name }}</b> ?
     <template v-slot:modal-footer>
       <!-- v-if="!submiting"
          :disabled="submiting" -->
        <b-button
          :disabled="submiting"
          size="sm"
          @click="onCloseForceCompleteModal"
          variant="outline-danger"
          >Close</b-button
        >
       
        <b-button
          @click="onSubmitForceCompleteModal"
          size="sm"
          variant="outline-success"
          :disabled="submiting"
          ><span v-if="submiting">
            <b-spinner small label="Spinning"></b-spinner>
          </span>
          <span v-else>Force Complete</span>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable */
import { HTTP } from "../../utils/HTTP";
import { Helper } from "@/helpers";

import moment from "moment";
import "moment/locale/es";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
export default {
  name: "EmployeeProfile",
  mixins: [validationMixin],

  data () {
    return {
      tagFirstLevelEmailValidatorState: null,
      tagFirstLevelRequiredValidatorState: null,
      tagSecondLevelEmailValidatorState: null,
      tagSecondLevelRequiredValidatorState: null,
      complianceEmailsData: null,
      showEditModal: false,
      form: {
        firstName: null,
        lastName: null,
        doj: null,
        email: null,
        country: null,
        preferredLanguage: null,
        department: null,
        firstLevelNonCompilanceValue: [],
        secondLevelNonCompilanceValue: [],
      },
      languageOptions: [],
      countryOptions: [],
      departmentsOptions: [],
      employeeRolesOptions: [],
      submiting: false,
      responseSuccess: false,
      invalidEmail: null,
      //
      exportDataIsLoading: false,
      employeeTasksLoading: false,
      tasksTotalRows: 0,
      tasksFromRows: 0,
      tasksToRows: 0,
      tasksFilter: null,
      tasksPerPage: 3,
      tasksCurrentPage: 1,
      tasksSortBy: "id",
      tasksSortDesc: true,
      tasksPageOptions: [5, 10, 25, 50, 75, 100],
      tasksFields: [
        { key: "task_title", label: "Title", sortable: true },
        { key: "created_at", label: "Date", sortable: true },
        // { key: "title", label: "Form Title", sortable: true },
        { key: "task_status", label: "Status", sortable: true },
        { key: "action", label: "Action", sortable: true },
      ],
      healthAndSafetytasksFields: [
        { key: "task_title", label: "Title", sortable: true },
        { key: "type", label: "Type", sortable: true },
        { key: "created_at", label: "Date", sortable: true },
        { key: "task_status", label: "Status", sortable: true },
        { key: "action", label: "Action", sortable: true },

      ],
      tasksFieldsArchived: [
        { key: "task_title", label: "Title", sortable: true },
        { key: "created_at", label: "Date", sortable: true },
        // { key: "title", label: "Form Title", sortable: true },
        { key: "task_status", label: "Status", sortable: true },
      ],
      healthAndSafetytasksFieldsArchived: [
        { key: "task_title", label: "Title", sortable: true },
        { key: "type", label: "Type", sortable: true },
        { key: "created_at", label: "Date", sortable: true },
        { key: "task_status", label: "Status", sortable: true },

      ],
      employeeGiftsLoading: false,
      giftsTotalRows: 0,
      giftsFromRows: 0,
      giftsToRows: 0,
      giftsFilter: null,
      giftsPerPage: 10,
      giftsCurrentPage: 1,
      giftsSortBy: "id",
      giftsSortDesc: true,
      giftsPageOptions: [5, 10, 25, 50, 75, 100],
      giftsFields: [
        {
          key: "title",
          label: "Type",
          sortable: true,
        },
        {
          key: "created_at",
          label: "Date Filed",
          sortable: true,
        },

        // {
        //   key: "currency",
        //   label: "Currency",
        //   sortable: true,
        // },
        {
          key: "amount",
          label: "Amount (USD)",
          sortable: true,
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
        },
        {
          key: "actions",
          label: "Action",
          sortable: false,
        },
      ],
      giftsFieldsArchived: [
        {
          key: "title",
          label: "Type",
          sortable: true,
        },
        {
          key: "created_at",
          label: "Date Filed",
          sortable: true,
        },

        // {
        //   key: "currency",
        //   label: "Currency",
        //   sortable: true,
        // },
        {
          key: "amount",
          label: "Amount (USD)",
          sortable: true,
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
        },
      ],
      profileImage: null,
      isLoading: false,
      employeData: {},
      totalRows: 0,
      filter: null,
      perPage: 10,
      currentPage: 1,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      staticFieldsDocuments: [
        {
          key: "File",
          label: "File",
          sortable: true,
        },
        {
          key: "date",
          label: "Date",
          sortable: true,
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
        },
      ],
      itemsDocuments: [
        {
          File: "TomCarlton_contract",
          date: "12 Jun 2020",
          status: "Uploaded",
        },
        {
          File: "TomCarlton_contract",
          date: "12 Jun 2020",
          status: "Uploaded",
        },
      ],
      statusKey: 0,
      showUpdateStatus: false,
      processing: false,
      counter: 1,
      interval: null,
      activityLogSortBy: "id",
      activityLogSortDesc: true,
      isLoadingActivityLog: false,
      activityLogData: [],
      deleteModal : false,
      deleteModalTitle: null,
      deleteTaskId: null,
      forceCompleteModal : false,
      forceCompleteModalTitle: null,
      forceCompleteTaskId: null,
      tableId: null,
    };
  },
  validations: {
    form: {
      firstName: {
        required,
      },
      lastName: {
        required,
      },
      email: {
        email,
        required,
      },
      department: {
        required,
      },
    },
  },
  computed: {

    tasksRows () {
      return this.tasksTotalRows;
    },
    giftsRows () {
      return this.giftsTotalRows;
    },
    // getEmployeeDetail(){
    //   return
    // }
    rows () {
      return this.totalRows;
    },
  },
  mounted () {
    this.getDepartmentsList();
    this.getEmployeeDetail();
    this.getActivityLog();
    //
    this.getEmployeeLanguages();
    this.getEmployeeCountry();
    // this.getFormData();
  },
  beforeDestroy () {
    this.clearInterval();
  },
  methods: {
    onShowForceCompleteModal(data,tableId){
      this.tableId = tableId
      this.forceCompleteModal = true
      this.forceCompleteModalTitle = data.item.task_title
      this.forceCompleteTaskId = data.item.id
    },
    onCloseForceCompleteModal(){
      this.forceCompleteModal = false
      this.forceCompleteModalTitle = null
      this.tableId = null
      this.forceCompleteTaskId = null
    },
    async onSubmitForceCompleteModal(){
      this.submiting = true;
      let userId = localStorage.getItem( "userId" );
       let token = "Bearer " + localStorage.getItem("accessToken");
       let formData = {
         user_id : userId,
         task_title : this.forceCompleteModalTitle,
         assigned_to : this.employeData.first_name + ' ' + this.employeData.last_name
       }
      
      try {
        let result = await HTTP(
          "post",
          `api/v1/governance/training/employee/task/force/complete/${this.forceCompleteTaskId}`,
          formData,
          {
            Authorization: token,
          }
        );
        this.submiting = false;
        Helper.makeToast(
        this.$bvToast,
        "success",
        "Force Completed successfully"
        );
        this.reloadTasksTable(this.tableId)
        this.onCloseForceCompleteModal()
      } catch (err) {
        this.submiting = false;
        return [err];
      }
    },
    onShowDeleteModal(data ,tableId){
      this.tableId = tableId
      this.deleteModal = true
      this.deleteModalTitle = data.item.task_title
      this.deleteTaskId = data.item.id
    },
    onCloseDeleteModal(){
      this.tableId = null
      this.deleteModal = false
      this.deleteModalTitle = null
      this.deleteTaskId = null
    },
    async onSubmitDeleteModal(){
      this.submiting = true;
      let userId = localStorage.getItem( "userId" );
       let token = "Bearer " + localStorage.getItem("accessToken");
       let formData = {
         user_id : userId,
         task_title : this.deleteModalTitle,
         assigned_to : this.employeData.first_name + ' ' + this.employeData.last_name
       }
      
      try {
        let result = await HTTP(
          "post",
          `api/v1/governance/training/employee/delete/task/${this.deleteTaskId}`,
          formData,
          {
            Authorization: token,
          }
        );
        this.submiting = false;
        Helper.makeToast(
        this.$bvToast,
        "success",
        "Deleted successfully"
        );
        this.reloadTasksTable(this.tableId)
        this.onCloseDeleteModal()
      } catch (err) {
        this.submiting = false;
        return [err];
      }
    },
    tagFirstEvent ( valid, invalid, duplicate ) {
      if ( invalid.length == 0 ) {
        this.tagFirstLevelEmailValidatorState = null;
      }
    },
    tagSecondEvent ( valid, invalid, duplicate ) {
      if ( invalid.length == 0 ) {
        this.tagSecondLevelEmailValidatorState = null;
      }
    },
    tagValidatorFirst ( value ) {
      let mailformat = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      // Individual tag validator function

      if ( mailformat.test( String( value ).toLowerCase() ) ) {
        this.tagFirstLevelEmailValidatorState = null;
        return true;
      } else {
        this.tagFirstLevelEmailValidatorState = false;
        return false;
      }
    },
    onInputFirstLevelEmailTag ( value ) {
      if ( value.length == 0 && this.tagFirstLevelEmailValidatorState == null ) {
        this.tagFirstLevelRequiredValidatorState = false;
      } else {
        this.tagFirstLevelRequiredValidatorState = null;
      }
    },
    tagValidatorSecond ( value ) {
      let mailformat = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      // Individual tag validator function

      if ( mailformat.test( String( value ).toLowerCase() ) ) {
        this.tagSecondLevelEmailValidatorState = null;
        return true;
      } else {
        this.tagSecondLevelEmailValidatorState = false;
        return false;
      }
    },
    onInputSecondLevelEmailTag ( value ) {
      if ( value.length == 0 && this.tagSecondLevelEmailValidatorState == null ) {
        this.tagSecondLevelRequiredValidatorState = false;
      } else {
        this.tagSecondLevelRequiredValidatorState = null;
      }
    },
    openEditModal () {
      this.showEditModal = true;
    },

    async getEmployeeLanguages () {
      this.languageOptions = [];
      this.isLoading = true;
      try {
        let result = await HTTP( "get", "api/v1/constants/languages-list", null );
        this.languageOptions = result.data.employeeLanuages;
        // console.log(this.languageOptions,'lang api')
        this.isLoading = false;
      } catch ( error ) {
        this.isLoading = false;
      }
    },
    formatDate ( value ) {
      if ( value ) {
        moment.locale( "en" );
        return moment( String( value ) ).format( "DD/MM/YYYY" );
      }
    },
    async getEmployeeCountry () {
      this.countryOptions = [];
      this.isLoading = true;
      try {
        let result = await HTTP( "get", "api/v1/constants/country-list", null );
        this.countryOptions = result.data.employeeCountry;
        this.isLoading = false;
      } catch ( error ) {
        this.isLoading = false;
      }
    },
    async getDepartmentsList () {
      this.departmentsOptions = [];
      this.isLoading = true;
      try {
        let result = await HTTP(
          "get",
          "api/v1/constants/departments-list",
          null
        );
        this.departmentsOptions = result.data.departments;
        this.isLoading = false;
      } catch ( error ) {
        this.isLoading = false;
      }
      // // console.log(this.departmentsOptions,"departmentsOptions")
    },
    async getEmployeeRoles () {
      this.employeeRolesOptions = [];
      this.isLoading = true;
      try {
        let result = await HTTP( "get", "api/v1/constants/roles", null );
        this.employeeRolesOptions = result.data.employeeRoles;
        this.isLoading = false;
      } catch ( error ) {
        this.isLoading = false;
      }
    },
    amountFormmater ( data ) {
      let amount = data.item.amount.replace( /\D/g, "" );
      return ( amount == '' ) ? 'N/A' : '$' + amount.replace( /\B(?=(\d{3})+(?!\d))/g, "," );
    },
    async checkEmailExist ( value ) {
      let formData = {
        email: value,
        user_id: localStorage.getItem( "userId" ),
        employee_id: this.employeData.id,
      };
      let result = HTTP( "post", "api/v1/employees/check-exist-email", formData );

      return result
        .then( ( response ) => {
          // console.log("response", response);
          if ( response.data.email == value ) {
            this.invalidEmail =
              "This Email Already Exist Please Change Email Address";
          } else if ( response.data === [] ) {
            return "";
          } else {
            this.invalidEmail = null;
          }
        } )
        .catch( ( error ) => {
          return [error];
        } );
    },

    resetForm () {
      this.showEditModal = false;
      // this.$v.$reset();
      // this.$forceUpdate()
      this.submiting = false;
      this.isLoading = false;
      this.responseSuccess = false;
      this.tagFirstLevelEmailValidatorState = null
      this.tagFirstLevelRequiredValidatorState = null
      this.tagSecondLevelEmailValidatorState = null
      this.tagSecondLevelRequiredValidatorState = null
      this.getEmployeeDetail();
    },

    checkValidation () {
      // console.log("updateFunction")
      if ( this.form.firstLevelNonCompilanceValue.length == 0 ) {
        this.tagFirstLevelEmailValidatorState = null;
        this.tagFirstLevelRequiredValidatorState = false;
      } else {
        this.tagFirstLevelRequiredValidatorState = null;
      }
      if ( this.form.secondLevelNonCompilanceValue.length == 0 ) {
        this.tagSecondLevelEmailValidatorState = null;
        this.tagSecondLevelRequiredValidatorState = false;
      } else {
        this.tagSecondLevelRequiredValidatorState = null;
      }

      this.$v.form.$touch();
      if ( this.$v.form.$anyError ) {
        return;
      } else {
        if ( this.invalidEmail ) {
          return;
        } else {
          if ( this.tagFirstLevelRequiredValidatorState == null && this.tagSecondLevelRequiredValidatorState == null
            && this.tagFirstLevelEmailValidatorState == null && this.tagSecondLevelEmailValidatorState == null
          ) {
            this.updateEmployee();
          }
        }
      }
    },
    makeToster ( tosterVarient, tosterMsg ) {
      this.resetForm();
      Helper.makeToast( this.$bvToast, tosterVarient, tosterMsg );
    },
    async updateEmployee () {
      // console.log(this.form,"formssdaata")
      let formData = {
        first_name: this.form.firstName,
        last_name: this.form.lastName,
        email: this.form.email,
        is_governance: 1,
        employee_email: this.form.email,
        date_of_joining: this.form.doj,
        employee_country_id: this.form.country ? this.form.country.value : null,
        employee_language_id: this.form.preferredLanguage,
        department_id: this.form.department ? this.form.department.value : null,
        employee_id: this.employeData.id,
        meta_data: {
          compliance_emails: {
            first_level: this.form.firstLevelNonCompilanceValue,
            second_level: this.form.secondLevelNonCompilanceValue

          }
        },
        // is_governance: this.form.isGovernance ? 1 : 0,
        userId: localStorage.getItem( "userId" ),
        user_id: localStorage.getItem( "userId" ),
      };
      try {
        this.submiting = true;
        this.isLoading = true;
        let result = await HTTP( "post", "api/v1/employees/update", formData );
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
        // console.log('success check',result.data.status)

        if ( result.data && result.data.status == 1 ) {
          this.makeToster(
            "success",
            "Employee information successfully Updated."
          );
          this.getEmployeeDetail();
        } else {
          this.makeToster( "danger", "Employee information Update failed." );
        }
      } catch ( err ) {
        console.log( "erorrUpdate", error.response || error );

        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = false;
        return [err];
      }
    },
    clearInterval () {
      if ( this.interval ) {
        clearInterval( this.interval );
        this.interval = null;
      }
    },
    async getActivityLog () {
      let formData = {
        activity_log_model_id: this.$route.params.id,
        activity_log_type: "Employee",
        user_id: localStorage.getItem( "userId" ),
        sort:
          this.activityLogSortBy +
          "|" +
          ( this.activityLogSortDesc == true ? "desc" : "asc" ),
      };
      this.isLoadingActivityLog = true;
      let response = await HTTP(
        "post",
        "api/v1/activitylog/get/with/type",
        formData
      );
      try {
        this.activityLogData = response.data.data;
        this.isLoadingActivityLog = false;
      } catch ( err ) {
        this.isLoadingActivityLog = false;
        return [err];
      } finally {
        this.scrollToEnd();
        this.isLoadingActivityLog = false;
      }
    },
    scrollToEnd () {
      var container = this.$el.querySelector( "#container" );
      container.scrollTop = container.scrollHeight + 120;
    },
    formatDate ( value ) {
      if ( value ) {
        moment.locale( "en" );
        return moment( String( value ) ).format( "DD MMMM, YYYY" );
      }
    },
    exportEmployeeData () {
      let userId = localStorage.getItem( "userId" );
      this.exportDataIsLoading = true;
      let result = HTTP(
        "get",
        "api/v1/governance/training/employee/rs/download/" +
        userId +
        "/" +
        this.employeData.id,
        null,
        null,
        null,
        null,
        "blob"
      );
      return result
        .then( ( response ) => {
          let blob = new Blob( [response.data], {
            type: "application/octet-stream",
          } );
          const url = window.URL.createObjectURL( blob );
          const link = document.createElement( "a" );
          link.href = url;
          link.setAttribute(
            "download",
            this.employeData.first_name +
            "_" +
            this.employeData.last_name +
            ".xlsx"
          ); //or any other extension
          document.body.appendChild( link );
          link.click();
          this.exportDataIsLoading = false;
        } )
        .catch( ( error ) => {
          this.exportDataIsLoading = false;
          return [error];
        } );
    },
    updateStatus ( status ) {
      this.statusKey = status;
      this.showUpdateStatus = true;
    },
    updateStatusCall () {
      this.counter = 1;
      this.processing = true;
      this.updateStatusApiCall();
      this.clearInterval();
      this.interval = setInterval( () => {
        if ( this.counter < 20 ) {
          this.counter = this.counter + 1;
        } else {
          this.clearInterval();
          this.$nextTick( () => {
            this.resetUpdateStatus();
            this.$router.push( "/goverance/one" );
          } );
        }
      }, 100 );
    },
    async updateStatusApiCall () {
      let formData = {
        status: this.statusKey,
        user_id: localStorage.getItem( "userId" ),
      };
      this.isLoading = true;
      await HTTP(
        "post",
        "api/v1/employees/update/status/" + this.$route.params.id,
        formData
      );
      try {
        this.isLoading = false;
      } catch ( err ) {
        this.isLoading = false;
        return [err];
      }
    },
    resetUpdateStatus () {
      this.showUpdateStatus = this.processing = false;
      this.statusKey = 0;
    },
    createdAtDate ( value ) {
      moment.locale( "en" );
      return moment( value ).format( "DD/MM/YYYY" );
    },
    setUserTaskUrl ( data ) {
      this.$store.state.selectedTaskType =
        "/employee-profile/" + this.$route.params.id;
      localStorage.setItem(
        "selected_task_type",
        this.$store.state.selectedTaskType
      );
      if (
        data.item.form_type == 1 ||
        data.item.form_type == 8 ||
        data.item.form_type == 10
      ) {
        localStorage.removeItem( "taskId" );
        localStorage.removeItem( "activeFormSchema" );
        localStorage.removeItem( "taskFormData" );
        localStorage.removeItem( "activeTaskStatus" );

        localStorage.setItem( "taskId", data.item.id );
        this.$router.push( "/emplyee-user-form/" + data.item.id + "/2" );
      } else if ( data.item.form_type == 6 ) {
        localStorage.removeItem( "taskId" );
        localStorage.removeItem( "activeFormSchema" );
        localStorage.removeItem( "taskFormData" );
        localStorage.removeItem( "activeTaskStatus" );

        localStorage.setItem( "taskId", data.item.id );
        this.$router.push( "/employee-pdf-training/" + data.item.id + "/2" );
      } else if ( data.item.form_type == 3 ) {
        localStorage.removeItem( "taskId" );
        localStorage.removeItem( "activeFormSchema" );
        localStorage.removeItem( "taskFormData" );
        localStorage.removeItem( "activeTaskStatus" );

        localStorage.setItem( "taskId", data.item.id );
        this.$router.push( "/emplyee-training/" + data.item.id + "/2" );
      } else if ( data.item.form_type == 11 ) {
        localStorage.removeItem( "taskId" );
        localStorage.removeItem( "activeFormSchema" );
        localStorage.removeItem( "taskFormData" );
        localStorage.removeItem( "activeTaskStatus" );

        localStorage.setItem( "taskId", data.item.id );
        this.$router.push( "/emplyee-training-exam/" + data.item.id + "/2" );
      }
    },
    reloadTasksTable (tableId) {
      this.$root.$emit( "bv::refresh::table", tableId );
    },
    async getOnboardingPolicyTaskData () {
      return this.getOnboardingTaskData( ["policy"] );
    },
    async getOnboardingTrainingTaskData () {
      return this.getOnboardingTaskData( ["trainings"] );
    },
    async getOnboardingCertificationTaskData () {
      return this.getOnboardingTaskData( ["certification"] );
    },
    async getOnboardingHealthAndSafetyTaskData () {
      return this.getOnboardingTaskData( ['health_and_safety_policy','health_and_safety_training'] );
    },
    getOnboardingTaskData ( type ) {
      let employeeId = this.$route.params.id;
      let formData = {
        task_types: type
        // filter: this.tasksFilter,
        // sort:
        //   this.tasksSortBy +
        //   "|" +
        //   ( this.tasksSortDesc == true ? "desc" : "asc" ),
        // per_page: this.tasksPerPage,
        // page: this.tasksCurrentPage,
      };
      this.employeeTasksLoading = true;
      let token = "Bearer " + localStorage.getItem( "accessToken" );
      let result = HTTP(
        "post",
        "api/v1/onboarding/employee/all/tasks/" + employeeId,
        formData,
        // let result = HTTP( "get", "api/v1/onboarding/employee/new/tasks/" + employeeId + "/" + type, formData,
        {
          Authorization: token,
        }
      );

      return result
        .then( ( response ) => {
          const items = response.data;
          this.employeeTasksLoading = false;
          return items;
        } )
        .catch( ( error ) => {
          this.employeeTasksLoading = false;
          return [error];
        } );
    },
    reloadGiftsTable () {
      this.$root.$emit( "bv::refresh::table", "gifts-data-table" );
    },
    async getApprovalsData () {
      let employeeId = this.$route.params.id;
      let formData = {
        filter: this.giftsFilter,
        sort:
          this.giftsSortBy +
          "|" +
          ( this.giftsSortDesc == true ? "desc" : "asc" ),
        per_page: this.giftsPerPage,
        page: this.giftsCurrentPage,
        employee_id: employeeId,
      };
      this.employeeGiftsLoading = true;
      let result = HTTP( "post", "api/v1/approvals/get", formData );

      return result
        .then( ( response ) => {
          const items = response.data.data;
          this.employeeGiftsLoading = false;
          this.giftsFromRows = response.data.from;
          this.giftsToRows = response.data.to;
          this.giftsTotalRows = response.data.total;
          return items;
        } )
        .catch( ( error ) => {
          this.employeeGiftsLoading = false;
          return [error];
        } );
    },
    async getEmployeeDetail () {
      let fromData = {
        employee_id: this.$route.params.id,
      };
      this.isLoading = true;
      let result = HTTP(
        "post",
        "api/v1/employees/get-employee-detail",
        fromData
      );
      return result
        .then( ( response ) => {
          if ( response.data.profile_img_url ) {
            this.profileImage = response.data.profile_img_url;
          }
          this.employeData = response.data;
          this.complianceEmailsData = JSON.parse( this.employeData.meta_data )
          this.form.firstLevelNonCompilanceValue = (this.complianceEmailsData && this.complianceEmailsData.compliance_emails && this.complianceEmailsData.compliance_emails.first_level) ? this.complianceEmailsData.compliance_emails.first_level : [];
          this.form.secondLevelNonCompilanceValue = (this.complianceEmailsData && this.complianceEmailsData.compliance_emails && this.complianceEmailsData.compliance_emails.second_level) ? this.complianceEmailsData.compliance_emails.second_level : [];
          this.isLoading = false;
          // console.log("employee data", this.employeData);
          let tempDepart = {
            value: this.employeData.department_id,
            text: this.employeData.department,
          };
          let tempCountry = {
            value: this.employeData.employee_country_id,
            text: this.employeData.country,
          };

          this.form.firstName = this.employeData.first_name;
          this.form.lastName = this.employeData.last_name;
          this.form.email = this.employeData.email;
          this.form.doj = this.employeData.date_of_joining;
          this.form.country = tempCountry;
          this.form.preferredLanguage = this.employeData.employee_language_id;
          this.form.department = tempDepart;

          // console.log(this.form, "getForm After");
        } )
        .catch( ( error ) => {
          console.log( "erorr", error.response || error );
          this.isLoading = false;
          return [error];
        } );
    },
  },
};
</script>

<style scoped>
@import "../../assets/styles/theme1/tabs.css";
@import "../../assets/styles/theme1/timeline.css";

.li {
  margin-bottom: 3px;
}

.img-style {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
  width: 100px;
}
.card-height {
  height: 325px;
  overflow: auto;
}
.existedEmailStyle {
  border-color: #e71d36 !important;
  padding-right: calc(1.5em + 0.75rem) !important;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e") !important;
  background-repeat: no-repeat !important;
  background-position: right calc(0.375em + 0.1875rem) center !important;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) !important;
}
.existedEmailStyle:focus {
  border-color: #e71d36 !important;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}
</style>

